module.exports = __webpack_public_path__ + "img/rouler_positions_5.bec3ea9a.png";